import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ChakraProvider, createSystem, defineConfig } from "@chakra-ui/react";
import { AppRoutes } from "./routes/AppRoutes";
import AuthContextProvider from 'contexts/AuthContext';
import FlashMessageContextProvider from 'contexts/FlashMessageContext';
import { FlashMessagesContainer } from './common/FlashMessage/FlashMessagesContainer';
import ErrorBoundary from './common/ErrorBoundary';
import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => {
    const config = defineConfig({
        theme: {
            tokens: {
                colors: {},
            },
        },
    });

    const system = createSystem(config);

    return (
        <Router>
            <FlashMessageContextProvider>
                <AuthContextProvider>
                    <ChakraProvider value={system}>
                        <div style={{ height: '100%' }}>
                            <FlashMessagesContainer/>
                            <ErrorBoundary>
                                <AppRoutes/>
                            </ErrorBoundary>
                        </div>
                    </ChakraProvider>
                </AuthContextProvider>
            </FlashMessageContextProvider>
        </Router>
    );
}

export default App;
